function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { Carrier, COUNTRY_CODES, FlatRatesTypes } from 'swag-common/constants/shipping.constants';
export let AllowedDeliveryOptionsForUSA = /*#__PURE__*/function (AllowedDeliveryOptionsForUSA) {
  AllowedDeliveryOptionsForUSA["Option-01"] = "Option-01";
  AllowedDeliveryOptionsForUSA["Option-02"] = "Option-02";
  AllowedDeliveryOptionsForUSA["Option-03"] = "Option-03";
  AllowedDeliveryOptionsForUSA["Option-12"] = "Option-12";
  AllowedDeliveryOptionsForUSA["Option-FedexGround"] = "Option-FedexGround";
  AllowedDeliveryOptionsForUSA["Option-DomesticFlatRate"] = "Option-DomesticFlatRate";
  AllowedDeliveryOptionsForUSA["Option-InternationalFlatRate"] = "Option-InternationalFlatRate";
  AllowedDeliveryOptionsForUSA["Option-Custom"] = "Option-Custom";
  AllowedDeliveryOptionsForUSA["Option-GND"] = "Option-GND";
  return AllowedDeliveryOptionsForUSA;
}({});
export const namesMap = {
  [AllowedDeliveryOptionsForUSA['Option-01']]: 'Next Day [1 Business Day]',
  [AllowedDeliveryOptionsForUSA['Option-02']]: '2 Day Air [2 Business Days]',
  [AllowedDeliveryOptionsForUSA['Option-03']]: 'Economy [Est. 5-7 Business Days]',
  [AllowedDeliveryOptionsForUSA['Option-12']]: '3 Day Air [3 Business Days]',
  [AllowedDeliveryOptionsForUSA['Option-FedexGround']]: 'Ground [Est. 3-5 Business Days]',
  [AllowedDeliveryOptionsForUSA['Option-DomesticFlatRate']]: '5-7 Business Days',
  [AllowedDeliveryOptionsForUSA['Option-InternationalFlatRate']]: '5-7 Business Days',
  [AllowedDeliveryOptionsForUSA['Option-Custom']]: '5-7 Business Days',
  [AllowedDeliveryOptionsForUSA['Option-GND']]: 'Domestic economy [Est. 3-8 Business Days]'
};
export let AllowedDeliveryOptionsForInternational = /*#__PURE__*/function (AllowedDeliveryOptionsForInternational) {
  AllowedDeliveryOptionsForInternational["Option-65"] = "Option-65";
  AllowedDeliveryOptionsForInternational["Option-PLY"] = "Option-PLY";
  return AllowedDeliveryOptionsForInternational;
}({});
export let FallbackDeliveryOptionsForInternational = /*#__PURE__*/function (FallbackDeliveryOptionsForInternational) {
  FallbackDeliveryOptionsForInternational["Option-07"] = "Option-07";
  FallbackDeliveryOptionsForInternational["Option-54"] = "Option-54";
  return FallbackDeliveryOptionsForInternational;
}({});
export const namesMapInternational = {
  [AllowedDeliveryOptionsForInternational['Option-65']]: 'International Standard [Est. 3-5 Business Days]',
  [AllowedDeliveryOptionsForInternational['Option-PLY']]: 'International Economy [Est. 5-14 Business Days]'
};
export const namesMapInternationalForVendor = {
  [AllowedDeliveryOptionsForInternational['Option-65']]: 'UPS Worldwide Saver',
  [AllowedDeliveryOptionsForInternational['Option-PLY']]: 'DHL Parcel International Standard'
};
export const fallbackNamesMapInternational = {
  [FallbackDeliveryOptionsForInternational['Option-07']]: 'Delivery by 12:00 noon',
  [FallbackDeliveryOptionsForInternational['Option-54']]: 'Delivery typically by 9:00 a.m.'
};
export const dayMapInternational = {
  [AllowedDeliveryOptionsForInternational['Option-65']]: {
    minDays: '3',
    maxDays: '5'
  }
};
export const renameDeliveryOptions = possibleDeliveries => {
  return Object.keys(possibleDeliveries).reduce((result, key) => {
    if (`Option-${key}` in AllowedDeliveryOptionsForUSA && +possibleDeliveries[key].maxDays < 10) {
      result[key] = _objectSpread({}, possibleDeliveries[key], {
        name: namesMap[`Option-${key}`],
        description: namesMap[`Option-${key}`]
      });
    } else {
      result[key] = possibleDeliveries[key];
    }
    return result;
  }, {});
};
export const renameDeliveryOptionsForActivityPage = possibleDeliveries => {
  const options = renameDeliveryOptions(possibleDeliveries);
  return Object.keys(options).reduce((result, key) => {
    if (key === '03') {
      result[key] = _objectSpread({}, possibleDeliveries[key], {
        name: 'Est 5-7 Business Days',
        description: 'Est 5-7 Business Days'
      });
    } else {
      result[key] = possibleDeliveries[key];
    }
    return result;
  }, {});
};
const filterDeliveryOptions = (possibleDeliveries, country) => {
  if (country !== COUNTRY_CODES.US) {
    return possibleDeliveries;
  }
  return Object.keys(possibleDeliveries).reduce((result, key) => {
    if (possibleDeliveries[key].carrier && possibleDeliveries[key].carrier !== Carrier.UPS || `Option-${key}` in AllowedDeliveryOptionsForUSA) {
      result[key] = possibleDeliveries[key];
    }
    return result;
  }, {});
};
const addFedexGround = possibleDeliveries => {
  if (!(possibleDeliveries !== null && possibleDeliveries !== void 0 && possibleDeliveries['03'])) {
    return possibleDeliveries;
  }
  return _objectSpread({}, possibleDeliveries, {
    ['03']: _objectSpread({}, possibleDeliveries['03'], {
      minDays: '5',
      maxDays: '7'
    }),
    ['FedexGround']: {
      name: 'Ground (Est. 3-5 Business Days)',
      description: 'Ground (Est. 3-5 Business Days)',
      serviceCode: 'FedexGround',
      shippingPrice: possibleDeliveries['03'].shippingPrice * 1.2,
      rawShippingPrice: possibleDeliveries['03'].rawShippingPrice,
      minDays: '3',
      maxDays: '5',
      carrier: Carrier.FEDEX
    }
  });
};
const addFedexGroundToCheckoutCharges = possibleDeliveries => _objectSpread({}, possibleDeliveries, {
  ['03']: _objectSpread({}, possibleDeliveries['03'], {
    minDays: 5,
    maxDays: 7
  }),
  ['FedexGround']: {
    name: 'Ground (Est. 3-5 Business Days)',
    description: 'Ground (Est. 3-5 Business Days)',
    serviceCode: 'FedexGround',
    upsCharge: (possibleDeliveries['03'].upsCharge || 0) * 1.2,
    totalCharges: (possibleDeliveries['03'].totalCharges || 0) * 1.2,
    shippingPrice: (possibleDeliveries['03'].shippingPrice || 0) * 1.2,
    minDays: 3,
    maxDays: 5,
    carrier: Carrier.FEDEX
  }
});
export const processDeliveryOptions = ({
  possibleDeliveries,
  country,
  skipPostalRates = false
}) => {
  if (country !== COUNTRY_CODES.US) {
    return possibleDeliveries;
  }
  const filtered = filterDeliveryOptions(possibleDeliveries, country);
  if (skipPostalRates) {
    return filtered;
  }
  return addFedexGround(filtered);
};
export const processDeliveryOptionsOnCheckout = (possibleDeliveries, country) => {
  if (country !== COUNTRY_CODES.US) {
    return possibleDeliveries;
  }
  const filtered = filterDeliveryOptions(possibleDeliveries, country);
  return addFedexGroundToCheckoutCharges(filtered);
};
export const swagToZonosInternationalDeliveryOptionsMap = {
  [FlatRatesTypes.Custom]: 'ups_express_saver',
  [FlatRatesTypes.International]: 'ups_express_saver',
  [AllowedDeliveryOptionsForInternational['Option-65']]: 'ups_express_saver',
  [AllowedDeliveryOptionsForInternational['Option-PLY']]: 'PLY',
  [FallbackDeliveryOptionsForInternational['Option-07']]: 'ups_express',
  [FallbackDeliveryOptionsForInternational['Option-54']]: 'ups_express_plus',
  // for rare cases, like delivery to Puerto Rico. UPS returns domestic US delivery options for this country
  [AllowedDeliveryOptionsForUSA['Option-01']]: 'ups_next_day_air',
  [AllowedDeliveryOptionsForUSA['Option-02']]: 'ups_2nd_day_air',
  [AllowedDeliveryOptionsForUSA['Option-03']]: 'ups_ground'
};
export const getZonosFromSwagDeliveryOption = option => {
  const optionPrefixed = `Option-${option}`;
  const zonosOption = swagToZonosInternationalDeliveryOptionsMap[optionPrefixed] || swagToZonosInternationalDeliveryOptionsMap[option];
  if (!zonosOption) {
    throw new Error(`Swag delivery option: "${optionPrefixed}" doesn't match any option for zonos`);
  }
  return zonosOption;
};